/**
 * Entfernt ein komplettes Set in EINEM Request.
 *
 * Ein Set besteht aus mehreren Line Items, die dieselbe Sternify-Property
 * _sternify_product_set + _sternify_tier tragen. Sie muessen gemeinsam
 * verschwinden: bei mehreren aufeinanderfolgenden /cart/change.js-Calls
 * rechnet die Sternify-Rabattfunktion zwischendurch mit einem unvollstaendigen
 * Set, der Set-Rabatt faellt weg und der Preis springt sichtbar.
 * /cart/update.js setzt alle Zeilen in einem Schritt auf 0.
 */
class CartRemoveSet extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.removeSet();
    });
  }

  removeSet() {
    const cartItems =
      this.closest("cart-items") || this.closest("cart-drawer-items");
    const keys = (this.dataset.keys || "").split(",").filter(Boolean);
    if (!cartItems || keys.length === 0) return;

    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });

    this.setLoading(true);

    const body = JSON.stringify({
      updates,
      sections: cartItems
        .getSectionsToRender()
        .map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const isEmpty = parsedState.item_count === 0;

        cartItems.classList.toggle("is-empty", isEmpty);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter) cartFooter.classList.toggle("is-empty", isEmpty);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", isEmpty);

        cartItems.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        if (isEmpty && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        }

        cartItems.updateProgressBar({
          total_price: parsedState.total_price,
          items_subtotal_price: parsedState.items_subtotal_price,
        });

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-remove-set",
          cartData: parsedState,
        });

        cartItems.updateCartUpsellToggleState();
        cartItems.updateCartUpsellVisibility(parsedState.item_count);
      })
      .catch(() => {
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  setLoading(isLoading) {
    const container =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    if (container)
      container.classList.toggle("cart__items--disabled", isLoading);

    const row = this.closest(".cart-item");
    if (!row) return;
    row
      .querySelectorAll(".loading__spinner")
      .forEach((overlay) => overlay.classList.toggle("hidden", !isLoading));
  }
}

customElements.define("cart-remove-set", CartRemoveSet);
